import { MTypography, Typography } from '@/shared/ui/typography';
import { useServices } from '@/store/api/services';
import cn from 'classnames';
import { motion, useInView } from 'framer-motion';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { useRef } from 'react';

export const MainTitlePage = () => {
  const { title } = useServices();
  const { i18n } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <section className={cn('bg-gray-5 mb:max-tb:overflow-hidden relative')}>
      <div className="dk:h-[363px] tb:h-[208px] mb:h-[129px] mb:max-tb:relative container flex justify-between">
        <Typography
          className="overflowX-hidden dk:mb-[23px] mb:mb-3 mb:max-tb:mt-[22px] relative mt-auto flex flex-col uppercase"
          variant="h1"
        >
          <MTypography ref={ref} variant="h1" as={'span'} className="w-fit ">
            {title}
          </MTypography>
          <motion.span
            className="bg-gray-5 absolute inset-0"
            style={{ clipPath: 'polygon(25% 0%, 100% 0%, 100% 100%, 0% 100%)' }}
            {...{
              initial: { left: '-40%' },
              animate: { left: '100%' },
            }}
            transition={{ duration: 1, ease: 'easeInOut' }}
          />
          {i18n.language === 'en' ? (
            <motion.span
              initial={{ clipPath: 'inset(0 100% 0 0)' }}
              animate={{
                clipPath: isInView ? 'inset(0 0 0 0)' : 'inset(0 100% 0 0)',
              }}
              transition={{ ease: 'easeInOut', duration: 0.4, delay: 1.7 }}
              className={cn(
                'bg-gray-5 absolute',
                'dk:h-[86px] dk:w-[21px] tb:h-[67px] tb:w-[18px] mb:h-[41px] mb:w-[10px]',
                'tb:left-[243.5px] tb:bottom-[25px] dk:left-[312px] dk:bottom-[31px] mb:left-[145.5px] mb:bottom-[51px]',
              )}
            >
              <Image alt="letter" src="/images/letters/letterEngI.svg" fill />
            </motion.span>
          ) : (
            <motion.span
              initial={{ clipPath: 'inset(0 100% 0 0)' }}
              animate={{
                clipPath: isInView ? 'inset(0 0 0 0)' : 'inset(0 100% 0 0)',
              }}
              transition={{ ease: 'easeInOut', duration: 0.4, delay: 1.7 }}
              className={cn(
                'bg-gray-5 absolute',
                'dk:h-[86px] dk:w-[99px] tb:h-[67px] tb:w-[60px] mb:h-[41px] mb:w-[36px]',
                'tb:left-[318.5px] tb:bottom-[25px] dk:left-[395px] dk:bottom-[31px] mb:left-[190px] mb:bottom-[51px]',
              )}
            >
              <Image alt="letter" src="/images/letters/letterI.svg" fill />
            </motion.span>
          )}
        </Typography>
        <motion.div
          className={cn(
            'mb:max-tb:hidden relative self-end',
            'dk:w-[444px] dk:h-[274px] tb:w-[298px] tb:h-[184px]',
          )}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ ease: 'easeInOut', duration: 0.4, delay: 0.6 }}
        >
          <Image
            className="h-full w-full object-cover"
            alt="logo"
            src="/images/services/logo.svg"
            fill
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ ease: 'easeInOut', duration: 0.4, delay: 0.6 }}
          className="tb:hidden"
        >
          <Image
            className={`absolute bottom-0 ${
              i18n.language === 'en'
                ? 'right-[0px] h-[77px] w-[97px]'
                : 'right-[15px] h-[100px] w-[126px]'
            }`}
            alt="logo"
            src="/images/services/logo_m.svg"
            width={126}
            height={100}
          />
        </motion.div>
      </div>
    </section>
  );
};
